import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ResellerType, ResellerRequest } from '../../../../models/api-store/reseller/reseller.request.model';
import { ResellerService } from '../../../../services/api-store/reseller/reseller.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-reseller-edit',
  templateUrl: './reseller-edit.component.html',
  styleUrls: ['./reseller-edit.component.css']
})
export class ResellerEditComponent implements OnInit {

  @Input() public id:number;

  formBuilder: FormGroup;
  request:any = {};
  isButtonSaveDisabled:boolean;
  typeSettings = {};
  selectedType = [];
  typeList = [
    { value: ResellerType.FRANCHISING },
    { value: ResellerType.MONOBRAND },
  ];

  
  constructor(
    private resellerService: ResellerService,
    private fb: FormBuilder,
    private toastr: ToastrService, 
    private spinner: SpinnerService,
    public activeModal: NgbActiveModal,
  ) { 
    this.initForm();
  }

  _typeSettings() {
    return {
      singleSelection: true,
      enableCheckAll: false,
      primaryKey: 'value',
      labelKey: 'value',
      searchBy: ['value'],
      showCheckbox: window.name,
      classes: 'form-control topic-select',
      lazyLoading: false,
      text: 'Tipologia',
      noDataLabel: 'Nessuna risultato con la ricerca associata',
      searchAutofocus: true,
      badgeShowLimit: 4
    };
  };

  ngOnInit(): void {
    this.loadDataByID(this.id);
    this.getSettings();
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }


  loadDataByID(idObj) {
    this.spinner.show();
    this.resellerService.getEntity(idObj).subscribe(
      (response) => {
        if (response) {
          this.setFormValue(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni della galleria', 'Caricamento galleria', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  initForm(){
    this.formBuilder = this.fb.group({
      region: ["", Validators.required],
      email: ["", [Validators.required, Validators.compose([
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
      ])]]
    });
    this.isButtonSaveDisabled = false;
  }


  getValue(){
    let request = new ResellerRequest();
    request.email = this.formBuilder.controls['email'].value;
    request.region = this.formBuilder.controls['region'].value;
    request.type = this.selectedType[0].value;
    return request;
  }

  setFormValue(response) {
    
    this.formBuilder.controls['email'].setValue(response.email);
    this.formBuilder.controls['region'].setValue(response.region);
    this.selectedType.push({value: response.type});
  }

  save(){
    this.request = this.getValue();
    this.resellerService.update(this.id, this.request).subscribe(
      (response) => {
        if(response){
          //Salvato
          this.toastr.success('Reseller modificato con successo' , 'Modifica Reseller', {
            timeOut: 5000
          });
          this.activeModal.close(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la madifica del Reseller' , 'Modifica Reseller', {
          timeOut: 5000
        });
        this.spinner.hide();
        this.isButtonSaveDisabled = false;
      }
    );
  }

  /**
   * Azione click su button salva modifiche
   */
  clickButtonSave(){
    if(this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE){
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  /**
   * Azione click su button Annulla
   */
  clickButtonCancel(){
    this.activeModal.close('CLOSE');
  }

  getSettings() {
    this.typeSettings = this._typeSettings();
  }
}
